<template lang="pug">
div
  h4 {{$t('groupPages.modules.contact.intro', {groupName: group.name}) }}
  form(role='form', method='post', onsubmit="return false", v-if='isConnected')
    .form-group
      input.form-control(v-validate="'required'", v-model="title", type="text", :placeholder="$t('groupPages.modules.contact.titlePlaceholder')", :disabled="status != null", :class="{'error': errors.has('title')}", name="title")
    .form-group
      textarea.form-control(v-validate="'required'", v-model="message", rows='5', :placeholder="$t('groupPages.modules.contact.messagePlaceholder')", :disabled="status != null", :class="{'error': errors.has('message')}", name="message")
    button.btn.btn-primary.pull-right(@click="sendMessage", :disabled="status != null") 
      i.fa.fa-send
      | &nbsp; {{$t('globals.send')}}
    p
      template(v-if="status == STATUS.SENDING") {{$t('globals.sending')}}
    .cf
  a.btn.btn-info(v-else, @click="connect", role='button') {{$t('groupPages.modules.contact.pleaseSignin') }}
</template>
<script>
import STATUS from '@/utils/status'
import {success, error} from '@/components/shared/Notify'
import {mapGetters} from 'vuex'

import modalsBus from '@/components/shared/ModalsBus'

export default {
  props: ['vueData', 'module', 'model'],
  data () {
    return {
      title: '',
      message: '',
      status: null,
      STATUS: STATUS
    }
  },
  computed: {
    ...mapGetters('user', [
      'isConnected'
    ]),
    group () {
      return this.vueData.group
    }
  },
  methods: {
    sendMessage () {
      this.$validator.validateAll().then(isSuccess => {
        if (!isSuccess) {
          return
        }
        this.status = STATUS.SENDING
        this.$store.dispatch('conversations/newConversation', this.group).then((conv) => {
          conv.title = this.title
          this.$store.dispatch('conversations/sendMessage', {
            conversation: conv,
            message: this.message
          }).then(() => {
            this.message = ''
            this.title = ''
            this.status = null
            success(this._i18n.t('conversations.notify.sendMessage.ok'))
            this.$nextTick(() => {
              this.$validator.reset()
            })
          }).catch(() => {
            error(this._i18n.t('globals.error'))
            this.status = null
          })
        })
      })
    },
    connect () {
      modalsBus.open(modalsBus.modals.CONNECTION)
    }
  }
}
</script>
<style lang="sass">
  .error
    background-color: rgba(255,0,0,0.05)
    animation: bounce 1s
</style>



// WEBPACK FOOTER //
// GroupPageContact.vue?5c4d1c08